import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { serviceWorkerManager, offlineStorageManager } from './utils/pwa';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize PWA functionality
async function initializePWA() {
  try {
    // Register service worker
    await serviceWorkerManager.register();
    
    // Initialize offline storage
    await offlineStorageManager.initialize();
    
    console.log('[PWA] Initialization complete');
  } catch (error) {
    console.error('[PWA] Initialization failed:', error);
  }
}

// Initialize PWA after React app is rendered
initializePWA();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
